var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4964 7.80005V15.6766C18.528 16.2551 18.3501 16.8237 18.0016 17.2589C17.653 17.694 17.162 17.9604 16.6354 18H3.36456C2.83799 17.9604 2.34699 17.694 1.99845 17.2589C1.64991 16.8237 1.47204 16.2551 1.50358 15.6766V7.80005",
    stroke: "#888888",
    strokeWidth: 2.108,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2673 14.4884L12.7076 11.7452L15.0358 9.13128C15.0721 9.09046 15.0939 9.04226 15.0986 8.99202C15.1034 8.94178 15.0909 8.89146 15.0627 8.8466C15.0344 8.80175 14.9914 8.76412 14.9385 8.73787C14.8855 8.71161 14.8247 8.69776 14.7626 8.69784L11.6494 8.69784L11.6494 1.0001L8.35164 1.0001L8.35164 8.69784L5.23659 8.69784C5.17456 8.69776 5.11371 8.71161 5.06076 8.73786C5.00781 8.76412 4.96483 8.80175 4.93657 8.8466C4.9083 8.89146 4.89585 8.94178 4.90059 8.99202C4.90534 9.04226 4.92709 9.09045 4.96344 9.13128L7.28435 11.7452L9.72465 14.4884C9.7559 14.523 9.79675 14.5512 9.84389 14.5706C9.89103 14.59 9.94314 14.6001 9.99599 14.6001C10.0488 14.6001 10.1009 14.59 10.1481 14.5706C10.1952 14.5512 10.2361 14.523 10.2673 14.4884Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.a7e274b71bc0e56e3b2358c1dea6da26.svg";
export { ForwardRef as ReactComponent };